import { BasePublicApi } from '#packages/apilib';
import {
  DEFAULT_WORKSPACE_MODE,
  NO_ZOOM_SCALE,
  WorkspaceModes,
} from './consts';

import type { WorkspaceModesScope } from './workspaceModesEntryPoint';

export const getMode = (): WorkspaceModes => {
  return DEFAULT_WORKSPACE_MODE;
};

export const isMode = (
  scope: WorkspaceModesScope,
  mode: WorkspaceModes,
): boolean => {
  return getMode() === mode;
};

const getWorkspaceModeDefaultScale = (): number => {
  return NO_ZOOM_SCALE;
};

export class WorkspaceModesApi extends BasePublicApi<WorkspaceModesScope> {
  isMode = this.bindScope(isMode);
  getWorkspaceModeDefaultScale = this.bindScope(getWorkspaceModeDefaultScale);
}
